import { render, staticRenderFns } from "./facturation.vue?vue&type=template&id=f43bbd54&scoped=true&"
import script from "./facturation.vue?vue&type=script&lang=js&"
export * from "./facturation.vue?vue&type=script&lang=js&"
import style0 from "./facturation.vue?vue&type=style&index=0&id=f43bbd54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43bbd54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
